import { Component, OnInit, OnDestroy, ContentChild, Output, EventEmitter, ElementRef } from '@angular/core';

import { Subject, fromEvent } from 'rxjs';
import { filter, switchMapTo } from 'rxjs/operators';

import { ViewModeDirective } from './view-mode.directive';
import { EditModeDirective } from './edit-mode.directive';
import { SubSink } from 'subsink';

/**Componente editabile, passa da readonly a edit con un evento di click e viceversa su click fuori focus */
@Component({
  selector: 'editable',
  template: `
    <ng-container
      *ngTemplateOutlet="currentView"></ng-container>
  `,
  styleUrls: ['./editable.component.css']
})
export class EditableComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  @ContentChild(ViewModeDirective, {static: true}) viewModeTpl: ViewModeDirective;
  @ContentChild(EditModeDirective, {static: true}) editModeTpl: EditModeDirective;
  @Output() update = new EventEmitter();

  editMode = new Subject();
  editMode$ = this.editMode.asObservable();

  mode: 'view' | 'edit' = 'view';

  /**
   * Costruttore per EditableComponente
   * @param host {ElementRef}
   */
  constructor(private host: ElementRef) { }

  /**Metodo dell'interfaccia OnInit nel quale richiamo i due metodi di gestione della modalità vista e della modalità edit */
  ngOnInit() {
    this.viewModeHandler();
    this.editModeHandler();
  }

  /**Metodo che gestisce il passaggio in modalità vista */
  toViewMode() {
    if(this.host.nativeElement.children[0].classList.contains('ng-valid')) { //effettuo l'update unicamente se l'input ha class ng-valid, quindi il form control è valido
      this.update.next();
      this.mode = 'view';  
    } 
  }

  /**Getter che recupera un elemento come nodo html */
  private get element() {
    return this.host.nativeElement;
  }

  /**Gestore della modalità vista che sottoscrive l'evento di click sull'elemento per lanciare la modalità edit*/
  private viewModeHandler() {
    this.subs.sink = fromEvent(this.element, 'click').subscribe(() => {
    // this.subsViewHandler = fromEvent(this.element, 'dblclick').subscribe(() => {
      this.mode = 'edit';
      this.editMode.next(true);
    });
  }

  /**Gestore della modalità edit che sottoscrive l'evento di click sul documento per lanciare la modalità vista nel caso in cui il target non sia contenuto nell'elemento */
  private editModeHandler() {
      const clickOutside$ = fromEvent(document, 'click').pipe(
        filter(({ target }) => this.element.contains(target) === false),
        // take(1)
      );
  
      this.subs.sink = this.editMode$.pipe(
        switchMapTo(clickOutside$)
      ).subscribe(event => this.toViewMode());
  }

  /**Getter della vista corrente */
  get currentView() {
    return this.mode === 'view' ? this.viewModeTpl.tpl : this.editModeTpl.tpl;
  }

  /**Metodo dell'interfaccia OnDestroy nel quale sono rimosse eventuali sottoscrizioni presenti */
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
